var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#41B64D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3258 36.4501C18.1785 36.4501 12.3906 29.3555 12.1494 17.55H17.2324C17.3993 26.2149 21.1466 29.8852 24.1148 30.6419V17.55H28.9009V25.023C31.8319 24.7014 34.9114 21.296 35.9502 17.55H40.7364C40.3449 19.4928 39.5646 21.3323 38.4442 22.9534C37.3238 24.5746 35.8875 25.9425 34.225 26.9717C36.0807 27.912 37.7197 29.2431 39.034 30.8769C40.3483 32.5107 41.3078 34.4102 41.8494 36.4501H36.581C36.0948 34.6783 35.1067 33.0923 33.7405 31.8909C32.3743 30.6894 30.6908 29.9259 28.9009 29.696V36.4501H28.3258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.1deebf410af4691358a9ddc32d7a719f.svg";
export { ForwardRef as ReactComponent };